import React from "react";

import "../Star.css";

const Star8 = () => {
  return (
    <span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star"></span>
    </span>
  );
};

export default Star8;
